import React, { useEffect, useState } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Switch, Route, useLocation, useHistory } from "react-router-dom";
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Badge from '@mui/material/Badge';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from './components/resources/spanet_logo.png';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import { mainListItems, mainListItemsHeatPump, adminListItems, dealerListItems, ssigListItems, adminDanielListItems } from './components/resources/listItems';
import SignIn from "./components/SignIn";
import SignInDealer from "./components/SignInDealer";
import SignInPIN from "./components/SignInPIN";
import Dashboard from './components/Dashboard';
import Control from './components/Control';
import History from './components/History';
import EEPROM from './components/EEPROM';
import OTA from './components/OTA';
import Blacklist from './components/Blacklist'
import HPDashboard from './components/HPDashboard';
import HPDashboardTemp from './components/HPDashboardTemp';
import HPSpecialFunctions from './components/HPSpecialFunctions';
import HPHistory from './components/HPHistory';
import HPEEPROM from './components/HPEEPROM';
import Users from './components/Users';
import Clients from './components/Clients';
import Spas from './components/Spas';
import DealerSpas from './components/DealerSpas';
import DealerList from './components/Dealers';
import SSIG from './components/SSIG';
import { Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import * as Constants from './components/api/constants'
import { MainRfContext } from './context/MainRfContext'
import { LoggedInUserContext } from './context/LoggedInUserContext'
import { reactLocalStorage } from 'reactjs-localstorage';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import theme from "./theme";
import AdminDashboard from './components/AdminDashboard';
import AppNotifications from './components/AppNotifications';
import AdminSettings from './components/AdminSettings';

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const mdTheme = createTheme();

function App() {
  const history = useHistory();
  const [open, setOpen] = useState(true);
  const [devices, setDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(0);
  const [R2, SetR2] = useState('');
  const [R3, SetR3] = useState('');
  const [R4, SetR4] = useState('');
  const [R5, SetR5] = useState('');
  const [R6, SetR6] = useState('');
  const [R7, SetR7] = useState('');
  const [R9, SetR9] = useState('');
  const [RA, SetRA] = useState('');
  const [RB, SetRB] = useState('');
  const [RC, SetRC] = useState('');
  const [RE, SetRE] = useState('');
  const [RG, SetRG] = useState('');
  const [RH, SetRH] = useState('');
  const [online, setOnline] = useState(false);
  const [rssi, setRssi] = useState(0);
  const [permission, setPermission] = useState(null);
  const [userId, setUserId] = useState(0);
  const [deviceId, setDeviceId] = useState(0);
  const [deviceName, setDeviceName] = useState('');
  const [deviceType, setDeviceType] = useState('');
  const [snWifiRf, setSnWifiRf] = useState('');
  const [snWifiR2, setSnWifiR2] = useState('');
  const [snSsigRf, setSnSsigRf] = useState('');
  const [snSsigR2, setSnSsigR2] = useState('');
  const [dealerUsername, setDealerUsername] = useState('');
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const [isReady, setIsReady] = useState(false);
  const [shouldGoToSSIG, setShouldGoToSSIG] = useState(false);

  const clearState = () => {
    reactLocalStorage.set('isLoggedIn', false);
    setDevices([]);
    setSelectedDevice(0);
    SetR2('');
    SetR3('');
    SetR4('');
    SetR5('');
    SetR6('');
    SetR7('');
    SetR9('');
    SetRA('');
    SetRB('');
    SetRC('');
    SetRE('');
    SetRG('');
    SetRH('');
    setOnline(false);
    setRssi(0);
    setUserId(0);
    setDeviceName('');
    setSnWifiRf('');
    setSnWifiR2('');
    setSnSsigRf('');
    setSnSsigR2('');

  }

  const getUserDevicesList = (userId) => {
    if (permission === null) {
      getUserPermission();
    }

    const requestOptions = {
      method: 'GET',
      credentials: "include"
    };

    const parameters = new URLSearchParams({
      userId: userId,
      deviceId: deviceId
    });

    fetch(Constants.baseURL + Constants.apiUserDevicesList + '?' + parameters, requestOptions)
      .then(response => {
        if (!response.ok && response.status !== 404) {
          // history.push('/');
        } else if (response.status === 404) {
          setDevices([]);
          setDeviceId(0)
          setSelectedDevice(0);
        }
        return response.json()
      })
      .then(data => {
        if (data.devices !== undefined) {
          setDevices(data.devices);
          if (data.devices.length > 0) {
            if (reactLocalStorage.get('selectedDevice', '0') !== '0') {
              setSelectedDevice(reactLocalStorage.get('selectedDevice', 0));
              getUserDeviceRf(reactLocalStorage.get('selectedDevice', 0));
            } else {
              setSelectedDevice(data.devices[0].id);
              getUserDeviceRf(data.devices[0].id);
            }
          }
        } else {
          setDevices([]);
          setSelectedDevice(0);
          SetR2('');
          SetR3('');
          SetR4('');
          SetR5('');
          SetR6('');
          SetR7('');
          SetR9('');
          SetRA('');
          SetRB('');
          SetRC('');
          SetRE('');
          SetRG('');
          SetRH('');
          setOnline(false);
          setRssi(0);
          setDeviceName('');
          setSnWifiRf('');
          setSnWifiR2('');
          setSnSsigRf('');
          setSnSsigR2('');
        }
      })
      .catch(error => { console.log('request failed', error); });
  }

  const getUserPermission = () => {
    const requestOptions = {
      method: 'GET',
      credentials: "include"
    };

    fetch(Constants.baseURL + Constants.apiGetUserPermissions, requestOptions)
      .then(response => {
        if (!response.ok && response.status !== 404) {
          history.push('/');
        }
        return response.json()
      })
      .then(data => {
        setPermission(data.permission);
        getDealerUsername();
      })
      .catch(error => { console.log('request failed', error); });
  }

  const refreshDeviceRF = (deviceId) => {
    const requestOptions = {
      method: 'GET',
      credentials: "include"
    };

    const parameters = new URLSearchParams({
      deviceId: deviceId,
      userId: userId
    });

    fetch(Constants.baseURL + Constants.apiDeviceRfRefresh + '?' + parameters, requestOptions)
      .then(response => {
        if (!response.ok && response.status !== 404) {
          history.push('/');
        }
      })
      .catch(error => { console.log('request failed', error); });
  }

  const getDealerUsername = () => {
    const requestOptions = {
      method: 'GET',
      credentials: "include"
    };

    fetch(Constants.baseURL + Constants.apiGetDealerUsername, requestOptions)
      .then(response => {
        return response.json()
      })
      .then(data => {
        if (data.name !== "") {
          setDealerUsername("Dealer - " + data.name)
        } else {
          setDealerUsername("Dealer Spas")
        }
      })
      .catch(error => { console.log('request failed', error); });
  }

  const userDeviceRfRefresh = (deviceId) => {
    const requestOptions = {
      method: 'GET',
      credentials: "include"
    };

    if (deviceId === 0) {
      deviceId = selectedDevice
    }

    const parameters = new URLSearchParams({
      deviceId: deviceId,
      userId: userId
    });

    fetch(Constants.baseURL + Constants.apiGetDeviceRfString + '?' + parameters, requestOptions)
      .then(response => {
        if (!response.ok && response.status !== 404) {
          history.push('/');
        }
        return response.json()
      })
      .then(data => {
        setTimeout(function () {
          getUserDeviceRf(deviceId);
        }, 4000);
      })
      .catch(error => { console.log('request failed', error); });
  }

  const getUserDeviceRf = (deviceId) => {
    const requestOptions = {
      method: 'GET',
      credentials: "include"
    };

    if (deviceId === 0) {
      deviceId = selectedDevice
    }

    const parameters = new URLSearchParams({
      deviceId: deviceId,
      userId: userId
    });

    fetch(Constants.baseURL + Constants.apiGetDeviceRfString + '?' + parameters, requestOptions)
      .then(response => {
        if (!response.ok && response.status !== 404) {
          history.push('/');
        }
        return response.json()
      })
      .then(data => {
        setDeviceType(data.deviceType);
        setDeviceName(data.deviceName);

        if (data.deviceType === 3) {
          setSnSsigRf(data.snSsigRf);
          setSnSsigR2(data.snSsigR2);
          setShouldGoToSSIG((data.snSsigRf ?? "") !== "");
          setIsReady(true);
          return;
        } else {
          const rfString =
            typeof data.deviceRf === 'string'
              ? data.deviceRf.split(':')
              : [];
          SetR2(rfString.length > 0 ? rfString[0] : "");
          SetR3(rfString.length > 1 ? rfString[1] : "");
          SetR4(rfString.length > 2 ? rfString[2] : "");
          SetR5(rfString.length > 3 ? rfString[3] : "");
          SetR6(rfString.length > 4 ? rfString[4] : "");
          SetR7(rfString.length > 5 ? rfString[5] : "");
          SetR9(rfString.length > 6 ? rfString[6] : "");
          SetRA(rfString.length > 7 ? rfString[7] : "");
          SetRB(rfString.length > 8 ? rfString[8] : "");
          SetRC(rfString.length > 9 ? rfString[9] : "");
          SetRE(rfString.length > 10 ? rfString[10] : "");
          SetRG(rfString.length > 11 ? rfString[11] : "");
          SetRH(rfString.length > 12 ? rfString[12] : "");

          setOnline(data.online ?? "");
          setRssi(data.rssi ?? "");
          setDeviceType(data.deviceType ?? "");
          setSnWifiRf(data.snWifiRf ?? "");
          setSnWifiR2(data.snWifiR2 ?? "");
        }
        setIsReady(true);
      })
      .catch(error => { console.log('request failed', error); });
  }

  const handleLogout = () => {
    clearState();
    window.localStorage.clear();
    reactLocalStorage.clear();
    reactLocalStorage.set('selectedDevice', 0);
    setSelectedDevice(0);
    setDevices([]);
    SetR2('');
    SetR3('');
    SetR4('');
    SetR5('');
    SetR6('');
    SetR7('');
    SetR9('');
    SetRA('');
    SetRB('');
    SetRC('');
    SetRE('');
    SetRG('');
    setPermission(null);
    setSnWifiRf('');
    setSnWifiR2('');
    setTimeout(() => {
      history.push('/');
    }, 1000);
  }

  const handleChangeDevice = (event) => {
    setSelectedDevice(event.target.value);
    getUserDeviceRf(event.target.value);
    reactLocalStorage.set('selectedDevice', event.target.value);
    setIsReady(false);
    setShouldGoToSSIG(false);
    history.push('/Dashboard');
  };

  const location = useLocation();
  const [title, setTitle] = useState("/");

  useEffect(() => {
    if (shouldGoToSSIG && snSsigRf && deviceId) {
      history.push('/SSIG');
    }
  }, [shouldGoToSSIG, snSsigRf]);

  useEffect(() => {
    reactLocalStorage.set('selectedDevice', 0);
    setSelectedDevice(0);
    setDevices([]);
    if (location.pathname !== '/' && location.pathname !== '/Admin' && location.pathname !== '/Dealer') {
      getUserDevicesList(userId);
    }
    SetR2('');
    SetR3('');
    SetR4('');
    SetR5('');
    SetR6('');
    SetR7('');
    SetR9('');
    SetRA('');
    SetRB('');
    SetRC('');
    SetRE('');
    SetRG('');
  }, [userId]);

  useEffect(() => {
    const pathName = location.pathname.toLowerCase();

    const publicAuthRoutes = ['/', '/dealer', '/admin', '/admindashboard'];

    const skipRfRoutes = [
      '/', '/dealer', '/admin',
      '/users', '/dealerspas', '/spas', '/clients', '/dealers',
      '/ota', '/blacklist', '/admindashboard'
    ];

    const isPublicAuthRoute = publicAuthRoutes.includes(pathName);
    const shouldSkipRfRefresh = skipRfRoutes.includes(pathName);

    const isLoggedIn = String(reactLocalStorage.get('isLoggedIn', false)) === 'true';

    if (!isLoggedIn && !isPublicAuthRoute) {
      history.push('/login');
      return;
    }

    if (isLoggedIn && !shouldSkipRfRefresh) {
      const storedSelectedDevice = Number(reactLocalStorage.get('selectedDevice', 0));
      const currentSelectedDevice = Number(selectedDevice);

      if (currentSelectedDevice === 0 || storedSelectedDevice === 0) {
        if (location.pathname !== '/' && Number(userId) === 0) {
          getUserDevicesList(0);
        }
      } else {
        const deviceIdToUse = currentSelectedDevice || storedSelectedDevice;
        getUserDeviceRf(deviceIdToUse);
        reactLocalStorage.set('selectedDevice', String(deviceIdToUse));
      }
    }

    switch (pathName) {
      case "/dashboard":
        if (isLoggedIn) getUserPermission();
        setTitle("Spa Controller | Dashboard");
        break;
      case "/control":
        setTitle("Spa Controller | Control");
        break;
      case "/history":
        setTitle("Spa Controller | History");
        break;
      case "/eeprom":
        setTitle("Spa Controller | Settings");
        break;
      case "/users":
        setTitle("Admin | Users");
        break;
      case "/spas":
        setTitle("Admin | Spas");
        break;
      case "/clients":
        setTitle("Admin | Clients");
        break;
      case "/ota":
        setTitle("Admin | OTA");
        break;
      case "/hpdashboard":
        setTitle("Heat Pump | Dashboard");
        break;
      case "/hpspecialfunctions":
        setTitle("Heat Pump | Special Functions");
        break;
      case "/hphistory":
        setTitle("Heat Pump | History");
        break;
      case "/hpeeprom":
        setTitle("Heat Pump | Settings");
        break;
      case "/admin":
        setTitle("Admin");
        break;
      case '/admindashboard':
        setTitle("Admin Dashboard");
        break;
      case "/dealer":
        setTitle("Dealer");
        break;
      case "/dealerspas":
        setTitle(dealerUsername);
        break;
      case "/dealers":
        setTitle("Admin | Dealers");
        break;
      case "/blacklist":
        setTitle("Admin | Blacklist");
        break;
      case "/ssig":
        setTitle("Smart Signal");
        if (isLoggedIn) getUserPermission();
        break;
      case "/appnotifications":
        setTitle("App Notifications");
        if (isLoggedIn) getUserPermission();
        break;
      case "/adminsettings":
        setTitle("Admin Settings");
        break;
      default:
        history.push('/');
        setTitle("SpaNET");
        break;
    }
  }, [location.pathname, selectedDevice, userId, dealerUsername]);

  if (
    !shouldGoToSSIG &&
    (RG === undefined || RG === '') &&
    (userId === undefined || userId === 0) &&
    location.pathname !== '/' &&
    devices.length !== 0
  ) {
    return (<div></div>)
  } else {
    return (
      <ThemeProvider theme={theme}>
        <LoggedInUserContext.Provider value={{}}>
          <Switch>
            <Route exact path='/' component={SignInPIN} />
            <Route exact path='/Admin' component={SignIn} />
            <Route exact path='/Dealer' component={SignInDealer} />
            <Box sx={{ display: 'flex' }}>
              <CssBaseline />
              <AppBar position="absolute" open={open}>
                <Toolbar
                  sx={{
                    pr: '24px',
                  }}
                >
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    onClick={toggleDrawer}
                    sx={{
                      marginRight: '36px',
                      ...(open && { display: 'none' }),
                    }}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Typography
                    component="h1"
                    variant="h6"
                    color="inherit"
                    noWrap
                    sx={{ flexGrow: 1 }}
                  >
                    {title}
                  </Typography>
                  <IconButton color="inherit">
                    <Badge badgeContent={0} color="secondary">
                      <RefreshIcon onClick={() => userDeviceRfRefresh(selectedDevice)} />
                    </Badge>
                  </IconButton>
                  <Select
                    labelStyle={{ color: '#ff0000' }}
                    sx={{
                      boxShadow: 'none',
                      color: "white",
                      '.MuiOutlinedInput-notchedOutline': {
                        border: 0
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: 0,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(228, 219, 233, 0.25)',
                      },
                      '.MuiSvgIcon-root ': {
                        fill: "white !important",
                      },
                    }}
                    value={selectedDevice}
                    onChange={handleChangeDevice}
                  >
                    {devices.map((el, i) => (<MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>))}
                  </Select>
                  <IconButton color="inherit">
                    <Badge badgeContent={0} color="secondary">
                      <LogoutIcon onClick={handleLogout} />
                    </Badge>
                  </IconButton>
                </Toolbar>
              </AppBar>
              <Drawer
                variant="permanent"
                open={open}
                sx={{
                  "& .MuiListItemButton-root": {
                    color: "inherit",

                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.08)",
                    },

                    "&.Mui-selected": {
                      backgroundColor: "rgba(255, 255, 255, 0.12)",
                    },

                    "&.Mui-selected:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.15)",
                    },
                  },

                  "& .MuiListItemText-primary": {
                    color: "inherit",
                  },

                  "& .MuiListItemIcon-root": {
                    color: "inherit",
                  },
                }}
              >
                <Toolbar
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                  }}
                >
                  <Box
                    component="img"
                    sx={{
                      height: 30,
                    }}
                    alt="SpaNET Logo"
                    src={logo}
                  />
                  <IconButton onClick={toggleDrawer}>
                    <ChevronLeftIcon />
                  </IconButton>
                </Toolbar>
                <Divider />
                <List component="nav">
                  {deviceType === 3 ? ssigListItems : (RE.split(',')[1] === '1' || RE.split(',')[1] === '2' ? mainListItemsHeatPump : mainListItems)}
                  {permission === 1 ? <Divider sx={{ my: 1 }} /> : <div></div>}
                  {permission === 1 ? adminListItems : ''}
                  {permission === 1 || permission === 2 ? <Divider sx={{ my: 1 }} /> : <div></div>}
                  {permission === 1 || permission === 2 ? dealerListItems : ''}
                </List>
              </Drawer>
              <Box
                component="main"
                sx={{
                  backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                      ? theme.palette.grey[100]
                      : theme.palette.grey[900],
                  flexGrow: 1,
                  height: '100vh',
                  overflow: 'auto',
                }}
              >
                <Toolbar />
                <MainRfContext.Provider value={{ permission, deviceName, R2, R3, R4, R5, R6, R7, R9, RA, RB, RC, RE, RG, RH, selectedDevice, getUserDeviceRf, refreshDeviceRF, online, rssi, deviceType, snWifiRf, snWifiR2, snSsigRf, snSsigR2, isReady }}>
                  <Route exact path="/Dashboard" component={Dashboard} />
                  <Route exact path="/Control" component={Control} />
                  <Route exact path="/History" component={History} />
                  <Route exact path="/EEPROM" component={EEPROM} />
                  <Route exact path="/Users" render={() => <Users {...{ userId, setUserId }} />} />
                  <Route exact path="/Clients" component={Clients} />
                  <Route exact path="/Spas" component={Spas} />
                  <Route exact path="/OTA" component={OTA} />
                  <Route exact path="/Blacklist" component={Blacklist} />
                  <Route exact path="/HPDashboard" component={HPDashboardTemp} />
                  <Route exact path="/DealerSpas" render={() => <DealerSpas {...{ deviceId, setDeviceId }} />} />
                  <Route exact path="/Dealers" component={DealerList} />
                  <Route exact path="/SSIG" component={SSIG} />
                  <Route exact path='/AdminDashboard' component={AdminDashboard} />
                  <Route exact path='/AppNotifications' component={AppNotifications} />
                  <Route exact path='/AdminSettings' component={AdminSettings} />
                </MainRfContext.Provider>
              </Box>
            </Box>
          </Switch>
        </LoggedInUserContext.Provider>
      </ThemeProvider>
    );
  }
}

export default App;